export type AgreementStatus =
  | 'Queued'
  | 'Sent to Manager'
  | 'Sent to Company'
  | 'Sent to Deputy Secretary'
  | 'Sent to Deputy Undersecretary'
  | 'Sent to Governor'
  | 'Expired'
  | 'Cancelled'
  | 'Executed'
  | 'Sent to Manager for Approval'
  | 'Sent to Agreement Reviewer for Approval';

export const agreementStatus = {
  queued: 'Queued',
  sentToManager: 'Sent to Manager',
  sentToCompany: 'Sent to Company',
  sentToDeputySecretary: 'Sent to Deputy Secretary',
  sentToDeputyUndersecretary: 'Sent to Deputy Undersecretary',
  sentToExecutiveDirectorOfOperations: 'Sent to Executive Director of Operations',
  sentToGovernor: 'Sent to Governor',
  expired: 'Expired',
  cancelled: 'Cancelled',
  executed: 'Executed',
  voided: 'Voided',
  sentToManagerForApproval: 'Sent to Manager for Approval',
  sentToAgreementReviewerForApproval: 'Sent to Agreement Reviewer for Approval'
};

export const agreementType = {
  contract: 'Contract',
  contractRenewal: 'Renewal Contract',
  contractAmendment: 'Contract Amendment',
  projectCompletionReport: 'Project Completion Report',
  certificationInitial: 'Initial Certification Letter',
  auditAttestation: 'Audit Attestation',
  evrAttestaiono: 'Expenditure Verification Report Attestation',
  irrevocableDesigneeLetter: 'Irrevocable Designee Letter',
  certificationFinal: 'Final Certification Letter',
  document: 'Document',
  stepGrantAwardContract: 'Step Grant Award Contract',
  declarationAuthorizedRepresentative: 'Declaration of Authorized Representative',
  other: 'Other'
};
